module.exports = __webpack_public_path__ + "static/media/placeholder-avatar.769a06d8.png";